import React from 'react';
import './ButtonSwitch.scss';

class ButtonSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    }
    this.trackKey = props.trackKey;
    this.clientId = props.clientId;
  }

  handleChange = event => {
    let newValue = event.target.checked;
    this.setState({value: newValue});

    let value = {};
    value[this.trackKey] = newValue;
    this.props.handleChange(this.clientId, value)
  }

  render() {
    let { value } = this.state;
    return (
      <label className="switch">
        <input
          name={this.trackKey}
          type="checkbox"
          defaultChecked={value}
          onChange={this.handleChange}
        />
        <span className="slider"></span>
      </label>
    );
  }
}

export default ButtonSwitch;
